import { lineActionTypes } from './lineActionTypes';

const { LIST_LINE, FILTER_LINE_NAME } = lineActionTypes;

export const Linelist = (lines) => {
	return {
		type: LIST_LINE,
		payload: lines,
	};
};

export const filterLineName = (lineName) => {
	return {
		type: FILTER_LINE_NAME,
		payload: lineName,
	};
};
